import React, { useEffect, useState, useRef, useMemo } from "react";
import SearchableSelect from "util/component/SearchableSelect";
import { DownloadFile } from "util";
import ModalPortal from "util/component/Modal";
import axios from 'util/axios';


const RevisionSelect = (props) => {
    const { sheetData, funcs } = props;

    const [Revision, SetRevision] = useState([]);
    const [Selected, SetSelected] = useState({});
    const [ModalShow, SetModalShow] = useState(null);

    const HandleRevisionValue = (select, option) => {
        SetSelected((OLD) => ({ ...OLD, [option.name]: select.value, compare: false }));
        funcs?.getTableData({
            [option.name.substr(-1) === "1" ? "left" : "right"]: select.value,
            tempYn: sheetData.tempYn
        });
    };

    useEffect(() => {
        if (sheetData) {
            SetSelected((OLD) => ({ ...OLD, revision2: sheetData?.revision + (sheetData?.tempYn === 'N' ? "T" : ""), compare: false }));
            funcs?.getTableData({
                right: sheetData?.revision + (sheetData?.tempYn === 'N' ? "T" : ""),
                tempYn: sheetData.tempYn
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sheetData])

    const HandleCompareClick = () => {
        if (!Selected.compare) {
            SetSelected(OLD => ({ ...OLD, compare: true }))
            funcs?.compare();
        }
    }

    const PDFDownload = async () => {
        const pdf = document.querySelectorAll(".table-container-inner > .right")
        const pdfs = [];
        const margin = "15";
        const fileName = sheetData.projectNm + "_" + sheetData.processCd + "_" + Selected.revision2.toString().replace(" ", "_") + "-" + Selected.revision1.toString().replace(" ", "") + ".pdf";

        const desc = document.querySelector(".desc-container-inner > .description-page > .ck-content")
        const descContent = desc.innerHTML;

        // Description
        let response;
        response = await axios.post(process.env.REACT_APP_API + "/diff/pdfGenerate", {
            html: descContent,
            margin: margin + "mm",
            size: "A4 portrait",
        });

        pdfs.push(response.data);


        SetModalShow({ state: "PDF Generating", totalCnt: pdf.length, processCnt: 1 })
        for (let p of pdf) {
            let type = "";
            switch (p.dataset?.tabletype) {
                case "IN":
                    type = `Operational Parameter`;
                    break;
                case "OUT":
                    type = `Performance Parameter`;
                    break;
                case "QC":
                    type = `Performance Parameter - QC`;
                    break;
                case "COMPOSITION":
                    type = `Composition`;
                    break;
                default:
                    type = "Data Table"
                    break;
            }
            type = `<h4 class='exclude_heading'>${type} (${sheetData?.description})</h4>`;
            response = await axios.post(process.env.REACT_APP_API + "/diff/pdfGenerate", {
                html: `<div id='pdf-container'>${type}${p.innerHTML}</div>`,
                margin: margin + "mm",
                size: "A4 landscape",
            });
            if (response?.data) {
                pdfs.push(response.data);
                SetModalShow(OLD => ({ ...OLD, processCnt: OLD.processCnt + 1 }))
            } else {
                throw new Error("Generate PDF got some Error");
            }

        }
        SetModalShow({ state: "PDF Merging" });



        await DownloadFile({
            api: "/diff/pdfMerge", body: {
                fileList: pdfs,
                fileName: fileName
            }, name: fileName
        },)

        SetModalShow(null)
    }

    const downloadExcel = async () => {
        const { sheetCode, projectNm, mbrNo } = sheetData;
        const { revision1, revision2 } = Selected;
        const postData = {
            sheetcd: sheetCode,
            revision: revision1.toString().replaceAll(/\D/g, ''),
            revision2: revision2.toString().replaceAll(/\D/g, ''),
            revisionTemp: revision1.toString().includes("T") ? "Y" : "N",
            revision2Temp: revision2.toString().includes("T") ? "Y" : "N",
        }
        const fileName = "compare_" + projectNm + mbrNo + "_" + revision2 + "-" + revision1 + ".xlsx";
        await DownloadFile({ api: "/diff/excelDownload", body: postData, name: fileName },)
    }

    const renderData = () => {
        return (
            <div className={"revisionSelect"}>
                <div className={"select-box"}>
                    <p>Reivision </p>
                    <div className={"inner"}>
                        <SearchableSelect
                            textAlign={"center"}
                            name="revision2"
                            search={false}
                            options={Revision}
                            value={Selected.revision2}
                            onChange={HandleRevisionValue}
                            revision={true}
                        />
                    </div>
                </div>
                <div className="text-box">
                    <p style={{ marginBottom: "10px" }}>Compare to</p>
                </div>
                <div className={"select-box"}>
                    <p>Reivision </p>
                    <div className={"inner"}>
                        <SearchableSelect
                            textAlign={"center"}
                            name="revision1"
                            search={false}
                            options={Revision}
                            value={Selected.revision1}
                            onChange={HandleRevisionValue}
                            revision={true}
                        />
                    </div>
                </div>
                <div className={"button-box"}>
                    <button
                        className={"bpl-btn main " + (Selected.compare ? "filled" : "")}
                        onClick={HandleCompareClick}
                        disabled={!(!!Selected.revision1 && !!Selected.revision2)}
                    >
                        Compare
                    </button>
                </div>

                <div className={"button-box"} style={{ marginLeft: "auto" }}>
                    <button
                        className={"bpl-btn success " + (Selected.compare ? "filled" : "")}
                        onClick={downloadExcel}
                        style={{ marginRight: "20px" }}
                        disabled={!Selected.compare}
                    >
                        Excel
                    </button>

                    <button
                        className={"bpl-btn success " + (Selected.compare ? "filled" : "")}
                        onClick={PDFDownload}
                        disabled={!Selected.compare}
                    >
                        PDF
                    </button>
                </div>
            </div>
        );
    };

    const render = useMemo(() => {

        if (Revision.length < 1) {
            return <h1 style={{ textAlign: "center" }}>There is no data to compare</h1>
        } else {
            return renderData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Revision.length, Selected.revision1, Selected.revision2, Selected.compare]);

    const initial = () => {
        try {
            const maxRevision = parseInt(sheetData.revision);
            const revisionSet = new Array(maxRevision).fill().map((v, i) => {
                return { label: i + 1, value: i + 1 };
            });
            if (sheetData?.tempYn === 'N') {
                revisionSet.push({ label: sheetData.revision, value: sheetData.revision + "T", temp: "Y" })
            }
            SetRevision(revisionSet);
        } catch (e) {
            console.error(e);
            SetRevision([]);
        }
    }

    useEffect(() => {
        initial();

        return (e) => {
            SetRevision([]);
            SetSelected({});
            funcs?.initial();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sheetData]);

    return <>
        {render}
        {ModalShow && <ModalPortal>
            <div className={"loadPop"}>
                <div className={"modalContainer"}>
                    <p>{ModalShow.state}</p>
                    {
                        ModalShow.totalCnt && <p>{ModalShow.processCnt}/{ModalShow.totalCnt}</p>
                    }
                </div>
            </div>
        </ModalPortal>}
    </>;
};

export default RevisionSelect;
